import React from 'react';
import styled from 'styled-components';
import SparklesIcon from "./assets/SparklesIcon";
import tokens from '../../../../common/styles/design-tokens';

const InsightBox = ({ text, title = "INSIGHT - How it Works" }) => (
    <InsightContainer>
        <InsightHeader>
            <IconWrapper>
                <SparklesIcon size="14px" />
            </IconWrapper>
            <InsightTitle>{title}</InsightTitle>
        </InsightHeader>
        <InsightTextWrapper>
            <InsightText>{text}</InsightText>
        </InsightTextWrapper>
    </InsightContainer>
);

export default InsightBox;

// --- Styles ---
const InsightContainer = styled.div`
    //background-color: #f0faff; /* Very light blue background */
    //border: 1px solid #d0eefc;  /* Subtle border */
    border-left: 3px solid ${tokens.colors.cyan};
    padding: 6px 10px;
    margin: 4px 0 8px 0;
    display: flex;
    flex-direction: column;
    gap: 8px;
`;

const InsightHeader = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
`;

const IconWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
`;

const InsightTitle = styled.div`
    font-size: ${tokens.typography.fontSize.xs};
    font-weight: ${tokens.typography.fontWeight.semibold};
    color: ${tokens.colors.cyan};
    text-transform: uppercase;
    letter-spacing: 0.5px;
`;

const InsightTextWrapper = styled.div`
    position: relative;
    max-height: calc(3 * 1.5em);
    overflow-y: auto;
    scrollbar-width: thin;
    scrollbar-color: ${tokens.colors['gray-300']} transparent;

    &::-webkit-scrollbar {
        width: 3px;
    }
    &::-webkit-scrollbar-thumb {
        background-color: ${tokens.colors['gray-300']};
        border-radius: 2px;
    }

    /* Sticky gradient fade pinned to bottom of scroll area */
    &::after {
        content: '';
        display: block;
        position: sticky;
        bottom: 0;
        height: 16px;
        margin-top: -16px;
        background: linear-gradient(transparent, white);
        pointer-events: none;
    }
`;

const InsightText = styled.p`
    font-size: ${tokens.typography.fontSize.xs};
    color: #4a4a4a;
    margin: 0;
    line-height: 1.5;
    padding-left: 20px;
`;